import { request } from '../request'

export function login (data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data
  })
}

//  用户注销登录
export function logout () {
  return request({
    url: '/sys/login',
    method: 'delete'
  })
}

export function getPubKey () {
  return request({
    url: '/sys/getPubKey',
    method: 'get'
  })
}

// 修改密码
export function resetMyPassword (data, token) {
  return request({
    url: '/sys/resetMyPassword?token=' + token,
    method: 'post',
    data
  })
}
